const comBg = (() => {
  const bgWraps = document.querySelectorAll('.js-com-bg-wrap');
  if (bgWraps.length > 0) {



    bgWraps.forEach((element, index) => {

      let span = element.querySelectorAll('span');

      let setDuration = 1
      const setValue = () => {
        let elementH = element.clientHeight;
        // console.log(element)
        // console.log(elementH)
        setDuration = elementH * 0.001 * 1.0
        // console.log(setDuration)
        return setDuration
      }
      // setValue()



      gsap.set(span, {
        scaleY: '0',
      })

      let to = gsap.to(span, {
        scaleY: '1',
        duration: () => setValue(),
        // duration: setDuration,
        ease: "power1.in",
        scrollTrigger: {
          trigger: element,
          start: "0% 80%",
          // markers: true
        },
        stagger: {
          each: 0.1,
          from: 'random'
        }
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          // setValue()
          to.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);

    });



  }
})();
export default comBg;